import { TooltipPositionerCallbackFunction } from "highcharts";
import { highchartsTooltipPositioner } from "@/storybook/c8r-highcharts/common/utils/tooltip/getTooltipOptions";

const tooltipOptionsPositioner: TooltipPositionerCallbackFunction = function (
  ...args
) {
  const { y, x } = highchartsTooltipPositioner.call(this, ...args);

  return { y: y + 35, x };
};

export const resourceDetailsCoverageChartTooltipOptions = {
  positioner: tooltipOptionsPositioner,
};
